export const INSIGHT_PERMISSION_ACTION_SUBJECT_ID = 'check-insight-permission';

export const USE_JQL_STORAGE = {
	namespace: 'jira-insights-should-use-jql',
	key: 'shouldUseJQLQuery',
} as const;
